import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { accountDetailDataConfig, accountDetailDownloadConfig } from './accountDetailData'

export const serviceConfig = defineSagaForService({
  ...accountDetailDataConfig,
})

export const fileDownloadConfig = {
  ...accountDetailDownloadConfig,
} as Record<string, DownloadServiceConfiguration>
